module.exports = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Locale': I18n.locale,
}
